import { useEffect, useLayoutEffect } from 'react';

import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { MyAccountContext } from 'pages/account/my_account/context';
import { helpContent } from 'pages/account/my_account/help';
import { FormattedMessage, useIntl } from 'react-intl';
import * as Tabs from 'pages/account/my_account/tabs';
import { Link, useLocation } from 'react-router-dom';
import { PageHeader } from 'components/layout/page';
import { DefaultLayout } from 'components/layout';
import { Nav, Tab } from 'react-bootstrap';
import { useSuperState } from 'hooks';
import { PermissionsApi } from 'apis';

export type UserPermissions = {
    Authenticate: boolean;
    Edit: boolean; // Partner Edit permission
    UserEdit: boolean
    UserView: boolean;
}

export type MyAccountContextValue = {
    permissions: UserPermissions;
}

export const MyAccount = () => {

    const [state, setState] = useSuperState({
        activeKey: 'general',
        loading: true,
        permissions: null as UserPermissions
    });
    const { activeKey, loading, permissions } = state;

    const { formatMessage } = useIntl();
    const location = useLocation();

    const fetchPermissions = async () => {

        try {

            const permissions = await PermissionsApi.Get('User');
            setState({ loading: false, permissions });

        } catch (e) {

            console.error(e);
            setState({ loading: false });

        }

    };

    useEffect(() => {

        fetchPermissions();

    }, []);

    useLayoutEffect(() => {

        setState({ activeKey: location?.hash.replace('#', '') || 'general' });

    }, [location?.hash]);

    const context: MyAccountContextValue = {
        permissions
    };

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'my_account.4d9a0b52', defaultMessage: 'My Account', description: 'New' })}>
            <MyAccountContext.Provider value={context}>
                <div className="my-account d-flex flex-column gap-3">
                    <PageHeader helpContent={helpContent} title={formatMessage({ id: 'my_account.4d9a0b52', defaultMessage: 'My Account', description: 'New' })} />

                    <div>
                        <Tab.Container activeKey={activeKey} unmountOnExit={true}>
                            <Nav variant="tabs">
                                <Nav.Item>
                                    <Nav.Link as={Link} disabled={loading} eventKey="general" to={'#general'}>

                                        <FormattedMessage defaultMessage="General" id="general.de730606" />
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link as={Link} disabled={loading} eventKey="password" to={'#password'}>

                                        <FormattedMessage defaultMessage="Password" id="password.19467d6e" />
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link as={Link} disabled={loading} eventKey="preferences" to={'#preferences'}>

                                        <FormattedMessage defaultMessage="Preferences" id="preferences.2bb53b2b" />
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>

                            {loading ?
                                (
                                    <div>
                                        <GMetrixLoader/>
                                    </div>
                                )
                                :
                                (
                                    <Tab.Content className="border border-top-0 p-4 bg-white">
                                        <Tab.Pane eventKey="general">
                                            <Tabs.General />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="password">
                                            <Tabs.Password />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="preferences">
                                            <Tabs.Preferences />
                                        </Tab.Pane>
                                    </Tab.Content>
                                )
                            }
                        </Tab.Container>
                    </div>

                </div>
            </MyAccountContext.Provider>
        </DefaultLayout>
    );

};